module.exports = __webpack_public_path__ + "static/media/vault.c9861924.png";